import React, { useMemo } from "react";

const COLORS = [
  "#FF9F40",
  "#FF6384",
  "#4BC0C0",
  "#36A2EB",
];

const FeaturesChart = ({ featureCounts = {}, loading = false }) => {
  const totalIncidents = useMemo(() => {
    if (featureCounts.Total !== undefined) {
      return featureCounts.Total;
    }
    return Object.values(featureCounts).reduce((a, b) => a + b, 0);
  }, [featureCounts]);

  if (loading) {
    return (
      <div className="bg-white rounded-lg border border-gray-300 p-6 mb-[10px]">
        <div className="text-gray-600">Loading metrics...</div>
      </div>
    );
  }

  if (!Object.keys(featureCounts).length) {
    return (
      <div className="bg-white rounded-lg border border-gray-300 p-6 mb-[10px]">
        <div className="text-gray-600">No data available</div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-lg border border-gray-300 p-6 mb-[10px]">
      <div className="flex gap-6">
        {Object.entries(featureCounts).map(([category, count], index) => {
          const percentage = ((count / totalIncidents) * 100).toFixed(0);
          return (
            <div key={category} className="flex items-center space-x-3">
              <div
                className="w-[5px] h-[30px] rounded-full"
                style={{ backgroundColor: COLORS[index % COLORS.length] }}
              />
              <div>
                <div className="text-sm text-gray-600">
                  {category} ({percentage}%)
                </div>
                <div className="text-2xl font-bold text-gray-800">{count}</div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FeaturesChart;
